import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// mui
import { Grid2 } from "@mui/material";
//styling
import styles from "./SitesOverview.module.scss";
// Icons
import { ReactComponent as Clonesite } from "../../../../../GlobalAssets/svg/Blueprint12.svg";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
// local import
import SitesOverviewCard from "../Components/SitesOverviewCard/SitesOverviewCard";
import { Actions } from "../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../Utils/storeUtils";
import { useSelector } from "react-redux";
import {
  adminApiClick,
  EmptyStateForSite,
  FEATURES,
  formatFileSize,
  NewEmptyStateForSite,
} from "../../../../../Utils/roconConstants";
import EmptyState from "../../../../../GlobalComponents/EmptyState/EmptyState";
import PageLoading from "../../../../../GlobalComponents/PageLoading/PageLoading";
import NewEmptyState from "../../../../../GlobalComponents/EmptyState/NewEmptyState";
import NewPopup from "../../../../../GlobalComponents/Popup/NewPopup";
import Dropdown from "../../../../../GlobalComponents/Dropdown/Dropdown";
import NoData from "../../../../../GlobalComponents/NoData/NoData";
import PlanExpiredCard from "../../../../../GlobalComponents/PlanExpiredCard/PlanExpiredCard";
import CustomButton from "../../../../../GlobalComponents/CustomButton/CustomButton";

export default function SitesOverview({ searchValue }) {
  const navigate = useNavigate();
  let sitesDetails = useSelector((state) => state.sitesInfo?.siteDetails?.data);

  let statusLb = useSelector((state) => state.sitesInfo?.siteArns ?? {});
  const specificPlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans,
  );
  const basePlan = specificPlan?.find((item) => item.basePlan === true) || {};
  const cancel = basePlan?.cancel;
  const daysAfterExpiry = basePlan?.daysAfterExpiry;

  const dedicatedHosting = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated === true,
  );
  const isSingleSite = specificPlan?.find((plan) => plan.isSingleSite === true);

  const params = useParams();
  const orgId = parseInt(params.orgId);

  const [filteredSites, setFilteredSites] = useState("");
  const [searchedSites, setSearchedSites] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [selectedSiteStatus, setSelectedSiteStatus] = useState([]);
  const [selectedWPAdminStatus, setSelectedWPAdminStatus] = useState([]);

  const siteStatusOptions = [
    { label: "Available", value: "Available" },
    { label: "Site down", value: "Site down" },
  ];
  const wpAdminStatusOptions = [
    { label: "Single Site", value: "Single Site" },
    { label: "Multisite Subdomain", value: "Multisite Subdomain" },
    { label: "Multisite Subdirectory", value: "Multisite Subdirectory" },
  ];

  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg,
  );

  const orgInfo = useSelector((state) => {
    return {
      orgId: state.organizationsInfo?.selectedOrg?.orgId,
      orgName: state.organizationsInfo?.selctedOrg?.name,
    };
  });

  useEffect(() => {
    // getStore().dispatch({
    //   type: Actions.API_ALL_SITES,
    //   data: { orgId: orgId },
    // });
    getStore().dispatch({ type: Actions.API_USER_DETAILS });
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });
    getStore().dispatch({
      type: Actions.API_SITE_OVERVIEW,
      data: {
        orgId: orgId,
      },
    });
  }, []);

  useEffect(() => {
    if (sitesDetails?.length > 0) {
      const FIFTEEN_MINUTES = 15 * 60 * 1000;
      const now = Date.now();
      // Filter sites that are in "provision" status and created within last 15 minutes
      const provisioningSites = sitesDetails.filter((site) => {
        const createdTs = now - site.createdTs;
        return site.status === "provision" && createdTs <= FIFTEEN_MINUTES;
      });

      if (provisioningSites.length > 0) {
        const intervalIds = provisioningSites.map((site) => {
          const intervalId = setInterval(() => {
            const currentTime = Date.now();
            const elapsedTime = currentTime - site.createdTs;
            if (elapsedTime > FIFTEEN_MINUTES) {
              clearInterval(intervalId);
              return;
            }
            getStore().dispatch({
              type: Actions.API_SITE_OVERVIEW,
              data: { orgId: orgId },
              meta: {
                onSuccess: () => {},
                onError: () => {},
              },
            });
          }, 60000);

          return intervalId;
        });
        return () => {
          intervalIds.forEach((id) => clearInterval(id));
        };
      }
    }
  }, [sitesDetails, orgId]);

  useEffect(() => {
    if (sitesDetails?.length > 0) {
      const FIFTEEN_MINUTES = 15 * 60 * 1000;
      const now = Date.now();

      sitesDetails.forEach((site) => {
        const createdTs = now - site.createdTs;
        if (site.status === "provision" && createdTs > FIFTEEN_MINUTES) return;
        getStore().dispatch({
          type: Actions.API_SITES_LB_ARN,
          data: {
            siteName: site.siteName,
            siteId: site.siteId,
          },
          meta: {
            onSuccess: () => {},
            onError: () => {},
          },
        });
      });
    }
  }, [sitesDetails, isSingleSite]);

  const siteDetails = () => {
    const getSiteDetails = (sitesArray) => {
      const siteStatus = Object.keys(statusLb).map((item) => ({
        siteId: parseInt(item),
        value: statusLb[item],
      }));

      return sitesArray?.map((siteDetail) => {
        const matchedStatus = siteStatus?.find(
          (status) => status.siteId === siteDetail?.siteId,
        );

        const mappedStatus =
          siteDetail?.status === "provision"
            ? siteDetail?.status
            : matchedStatus
              ? matchedStatus.value
              : "";

        return {
          siteName: siteDetail?.siteName,
          siteId: siteDetail?.siteId,
          features: siteDetail?.featuresUsageRes?.map((item) => ({
            limit: item.limitOrAvailablity,
            type: item.type,
            used: item.used,
          })),
          status: mappedStatus,
          domainName: siteDetail?.siteDomainName,
          installType: siteDetail?.installType,
          environment: siteDetail?.environment,
          imagePath: siteDetail?.imagePath,
          addOns: siteDetail?.addOns,
          deletionInProgress: siteDetail?.deletionInProgress,
        };
      });
    };

    let siteInfo;
    if (orgId === orgInfo?.orgId) {
      siteInfo = sitesDetails?.length > 0 ? getSiteDetails(sitesDetails) : [];
    } else {
      siteInfo = sitesDetails?.length > 0 ? getSiteDetails(sitesDetails) : [];
    }

    return siteInfo;
  };

  const siteData = siteDetails();
  const setSitesSearch = (searchValue) => {
    const dataToSearch = filteredSites?.length > 0 ? filteredSites : siteData;

    if (searchValue.trim() === "") {
      return dataToSearch;
    } else {
      return dataToSearch?.filter((site) =>
        site.siteName?.toLowerCase().includes(searchValue?.toLowerCase()),
      );
    }
  };

  useEffect(() => {
    const filtered = setSitesSearch(searchValue);
    setSearchedSites(filtered);
  }, [searchValue]);

  const getFeatureValue = (features, type) =>
    features?.find((f) => f.type === type)?.used || "N/A";

  const handleOpenFilter = () => {
    setIsFilterOpen(true);
  };

  const handleCloseFilter = () => {
    setIsFilterOpen(false);
    setFilterApplied(false);
  };

  const handleClearFilter = () => {
    setIsFilterOpen(false);
    setSelectedSiteStatus("");
    setSelectedWPAdminStatus("");
    setFilteredSites("");
    setFilterApplied(false);
  };

  const handleSelectSiteStatus = (newValues) => {
    setSelectedSiteStatus(newValues);
    setFilterApplied(false);
  };

  const handleSelectWpStatus = (newValues) => {
    setSelectedWPAdminStatus(newValues);
    setFilterApplied(false);
  };

  const handleFilter = () => {
    setFilterApplied(true);
    if (selectedSiteStatus?.length > 0 || selectedWPAdminStatus?.length > 0) {
      const filteredResults = siteData?.filter((site) => {
        let filtered = true;

        if (selectedSiteStatus?.length > 0) {
          const isStatusMatch =
            site.status === true ? "Available" : "Site down";
          filtered = filtered && selectedSiteStatus.includes(isStatusMatch);
        }

        if (selectedWPAdminStatus?.length > 0) {
          filtered =
            filtered && selectedWPAdminStatus.includes(site.installType);
        }

        return filtered;
      });

      setFilteredSites(filteredResults);
      setIsFilterOpen(false);
    }
  };

  // const showSites =
  //   searchValue?.length > 0 && filteredSites?.length > 0
  //     ? searchedSites
  //     : filterApplied && filteredSites?.length > 0 ||
  //       filteredSites?.length === 0
  //     ? filteredSites
  //     : searchValue && searchValue?.length > 0
  //     ? searchedSites
  //     : siteData;

  const showSites =
    searchValue?.length > 0 && filteredSites?.length > 0
      ? searchedSites
      : filteredSites
        ? filteredSites
        : searchValue?.length > 0
          ? searchedSites
          : siteData;

  const isDisable =
    filterApplied ||
    (selectedSiteStatus?.length === 0 && selectedWPAdminStatus?.length === 0);

  return (
    <>
      {sitesDetails ? (
        <>
          {specificPlan?.length > 0 ? (
            <Grid2 className={styles.Container}>
              {siteData?.length > 0 && (
                <Grid2 className={styles.header}>
                  <Grid2>Sites</Grid2>
                  <Grid2 className={styles.headerRight}>
                    <CustomButton
                      className={styles.button}
                      onClick={() => {
                        navigate(`/account/${orgId}/create`);
                      }}
                    >
                      Create Site
                    </CustomButton>
                    <Grid2 className={styles.filter} onClick={handleOpenFilter}>
                      <FilterListOutlinedIcon />
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}

              {showSites && showSites?.length > 0 ? (
                <>
                  {showSites.map((item, index) => {
                    const {
                      features,
                      siteName,
                      status,
                      imagePath,
                      siteId,
                      domainName,
                      environment,
                      addOns,
                      deletionInProgress,
                    } = item;

                    const phpAdminClick =
                      status === "provision" || deletionInProgress
                        ? null
                        : () => adminApiClick("php");
                    const wPAdminClick =
                      status === "provision" || deletionInProgress
                        ? null
                        : () => adminApiClick("wp", domainName);
                    const domainClick =
                      status === "provision" || deletionInProgress
                        ? null
                        : () => adminApiClick("domain", domainName);

                    const envlive =
                      environment.find((env) => env.LIVE)?.LIVE || null;
                    const envstage =
                      environment.find((env) => env.STAGING)?.STAGING || null;
                    const liveIds =
                      environment.find((env) => env.LIVE)?.id || null;

                    return (
                      <SitesOverviewCard
                        key={index}
                        name={siteName}
                        status={status}
                        storage={
                          features.some(
                            (f) =>
                              f.type === FEATURES.STORAGE && f.used === "0",
                          )
                            ? "0 B"
                            : formatFileSize(
                                getFeatureValue(features, FEATURES.STORAGE),
                              )
                        }
                        bandwidth={
                          features.some(
                            (f) =>
                              f.type === FEATURES.BANDWIDTH && f.used === "0",
                          )
                            ? "0 B"
                            : formatFileSize(
                                getFeatureValue(features, FEATURES.BANDWIDTH),
                              )
                        }
                        visits={getFeatureValue(features, FEATURES.VISIT)}
                        production={envlive}
                        staging={envstage}
                        domain={domainName}
                        phpAdmin={"PHP Admin"}
                        wPAdmin={"Wp Admin"}
                        phpAdminClick={phpAdminClick}
                        wPAdminClick={wPAdminClick}
                        domainClick={domainClick}
                        orgname={orgInfo?.orgName}
                        sitename={siteName}
                        image={imagePath}
                        siteId={siteId}
                        orgId={orgId}
                        selectedOrg={selectedOrg}
                        addOns={addOns}
                        selectedDomain={liveIds}
                        deletionInProgress={deletionInProgress}
                        dedicatedHosting={dedicatedHosting}
                      />
                    );
                  })}
                </>
              ) : (filterApplied && filteredSites?.length === 0) ||
                (searchValue && searchedSites?.length === 0) ? (
                <NoData
                  message={
                    filterApplied
                      ? "No Filtered Sites found"
                      : "No searched Sites found"
                  }
                  noDataStyle={styles.noData}
                />
              ) : (
                <EmptyState
                  header={EmptyStateForSite.header}
                  subHeader={EmptyStateForSite.subHeader}
                  // icon={Clonesite}
                  title={EmptyStateForSite.title}
                  subTitle={EmptyStateForSite.subTitle}
                  title1={EmptyStateForSite.title1}
                  subTitle1={EmptyStateForSite.subTitle1}
                  subTitle2={EmptyStateForSite.subTitle2}
                  subTitle3={EmptyStateForSite.subTitle3}
                  create={EmptyStateForSite.create}
                  onClick={() => {
                    navigate(`/account/${orgId}/create`);
                  }}
                  docsheader={EmptyStateForSite.docsheader}
                  docsSubheader={EmptyStateForSite.docsSubheader}
                  docsbutton={EmptyStateForSite.docsbutton}
                  docsbuttonOnclick={() => {
                    window.open(
                      "https://docs.roconpaas.io/home/create-site/",
                      "_blank",
                    );
                  }}
                  liveHeader={EmptyStateForSite.liveHeader}
                  liveSubheader={EmptyStateForSite.liveSubheader}
                  liveButton={EmptyStateForSite.liveButton}
                  livebuttonOnclick={() => {
                    window.open(
                      "https://docs.roconpaas.io/home/create-site/",
                      "_blank",
                    );
                  }}
                />
              )}

              {((cancel === true && daysAfterExpiry >= 2) ||
                daysAfterExpiry >= 2) && (
                <PlanExpiredCard org={selectedOrg} plan={basePlan} />
              )}
            </Grid2>
          ) : (
            <NewEmptyState
              header={NewEmptyStateForSite.header}
              subHeader={NewEmptyStateForSite.subHeader}
              icon={Clonesite}
              title={
                <span>
                  Get Your WordPress Site
                  <span style={{ color: "#135FC2" }}> Live </span>Today
                </span>
              }
              subTitle={NewEmptyStateForSite.subTitle}
            />
          )}
        </>
      ) : (
        <PageLoading />
      )}
      <NewPopup
        trigger={isFilterOpen}
        closePopup={handleCloseFilter}
        header={"Sites Filter"}
        customWidth={"30%"}
        backPopup={"Clear"}
        backOnClick={handleClearFilter}
        nextpopup={"Apply"}
        nextOnClick={handleFilter}
        disabled={isDisable}
      >
        <Dropdown
          placeholder="Select Site's Status"
          options={siteStatusOptions}
          value={selectedSiteStatus}
          onSelect={handleSelectSiteStatus}
          multiple={true}
        />
        <Dropdown
          placeholder="Select Site's WP Status"
          options={wpAdminStatusOptions}
          value={selectedWPAdminStatus}
          onSelect={handleSelectWpStatus}
          multiple={true}
        />
      </NewPopup>
    </>
  );
}
